import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';
import { Menu } from '../Menu';

export const ContentElement = styled.div`
    display: flex;
    align-items: center;
    & > *:last-child {
        margin-left: ${getSpacingToken('100')}px;
    }
`;

/* Handle first group separator visibility directly with CSS */
export const StyledMenu = styled(Menu)`
    & > [role='group'] {
        &:first-of-type {
            & > [role='separator'] {
                display: none;
            }
        }
    }
`;
